<template>
  <Layout style="min-height: 90vh">
    <Layout>
      <Content>
        <Row style="margin-top:3px;" type="flex" justify="space-around">
          <Col span="23">
            <Card :padding="0">
              <h3 slot="title">This month score: {{ scoreThisMonth }}</h3>
              <div style="padding: 16px;">
                <RadioGroup
                  style="margin-right: 10px;"
                  type="button"
                  :size="$mq == 'lg' ? 'default' : 'small'"
                >
                  <Radio
                    label="yesterday"
                    @click.native="designDateRangeInput = yesterday; getDesignReport()"
                  >Yesterday</Radio>
                  <Radio
                    label="last7Days"
                    @click.native="designDateRangeInput = last7Days; getDesignReport()"
                  >{{$mq == 'lg' ? 'Last 7 days' : '7D'}}</Radio>
                  <Radio
                    label="thisMonth"
                    @click.native="designDateRangeInput = thisMonth; getDesignReport()"
                  >{{$mq == 'lg' ? 'This month' : 'TM'}}</Radio>
                  <Radio
                    label="lastMonth"
                    @click.native="designDateRangeInput = lastMonth; getDesignReport()"
                  >{{$mq == 'lg' ? 'Last month' : 'LM'}}</Radio>
                  <Radio
                    label="allTime"
                    @click.native="designDateRangeInput = allTime; getDesignReport()"
                  >{{$mq == 'lg' ? 'All time' : 'All'}}</Radio>
                </RadioGroup>
                <Br v-if="$mq != 'lg'" />
                <DatePicker
                  transfer
                  :disabled="$mq == 'lg' ? false : true"
                  :size="$mq == 'lg' ? 'default' : 'small'"
                  type="daterange"
                  v-model="designDateRangeInput"
                  placement="right"
                  placeholder="Select date"
                  :style="`width: 200px; ${$mq == 'lg' ? '' : 'margin-top: 3px;'}`"
                  @on-change="getDesignReport"
                ></DatePicker>

                <Table
                  border
                  :columns="$mq == 'lg' ? designReportTitle : designReportTitleResponsive"
                  :data="designReport"
                  style="margin-top: 10px;"
                >
                  <template slot-scope="{ row, index }" slot="design">
                    <p>
                      <a
                        :href="'https://www.amazon.com/dp/' + row.design[0].productId"
                        target="_blank"
                      >{{ row.design[0].title }}</a>
                    </p>
                  </template>
                </Table>
              </div>
            </Card>
          </Col>
        </Row>
      </Content>
    </Layout>
  </Layout>
</template>
<script>
import api from '@/api'

export default {
  name: 'home',
  components: {},
  data: () => {
    return {
      user: {},
      scoreThisMonth: 0,
      designReportTitle: [
        {
          title: 'Design',
          slot: 'design',
          width: '550px'
        },
        {
          title: 'Purchased',
          key: 'purchased'
        },
        {
          title: 'Cancelled',
          key: 'cancelled'
        },
        {
          title: 'Returned',
          key: 'returned'
        }
      ],
      designReportTitleResponsive: [
        {
          title: 'Design',
          slot: 'design',
          width: '220px'
        },
        {
          title: 'Purchased',
          key: 'purchased'
        }
      ],
      designReport: [],
      designDateRangeInput: []
    }
  },
  created: function() {
    this.user = this.$store.state.auth.user
  },
  async mounted() {
    this.designDateRangeInput = this.thisMonth
    this.getScore()
    this.getDesignReport()
  },
  computed: {
    today: function() {
      let now = new Date()
      now.setUTCHours(0, 0, 0, 0)
      return now
    },
    yesterday: function() {
      let yesterday = new Date()
      yesterday.setDate(yesterday.getDate() - 1)
      yesterday.setUTCHours(0, 0, 0, 0)
      return [yesterday, this.today]
    },
    last7Days: function() {
      let last7Days = new Date()
      last7Days.setDate(last7Days.getDate() - 7)
      last7Days.setUTCHours(0, 0, 0, 0)
      return [last7Days, this.today]
    },
    thisMonth: function() {
      let date = new Date()
      let thisYear = date.getFullYear()
      let thisMonth = date.getMonth()
      let startThisMonth = new Date(thisYear, thisMonth, 2)
      startThisMonth.setUTCHours(0, 0, 0, 0)
      let endThisMonth = new Date(thisYear, thisMonth + 1, 1)
      endThisMonth.setUTCHours(0, 0, 0, 0)
      return [startThisMonth, endThisMonth]
    },
    lastMonth: function() {
      let date = new Date()
      let thisYear = date.getFullYear()
      let thisMonth = date.getMonth()
      let startLastMonth = new Date(thisYear, thisMonth - 1, 2)
      startLastMonth.setUTCHours(0, 0, 0, 0)
      let endLastMonth = new Date(thisYear, thisMonth, 1)
      endLastMonth.setUTCHours(0, 0, 0, 0)
      return [startLastMonth, endLastMonth]
    },
    allTime: function() {
      let start = new Date('2019-1-2')
      start.setUTCHours(0, 0, 0, 0)
      return [start, this.today]
    }
  },
  methods: {
    getScore() {
      let startRange = this.thisMonth[0].toISOString()
      let endRange = this.thisMonth[1].toISOString()
      let queryString = '?limit=100&date>=' + startRange + '&date<=' + endRange
      api({
        method: 'get',
        url: 'reports/score' + queryString
      })
        .then(res => {
          this.scoreThisMonth = res.data.designScore
        })
        .catch(error => {
          this.$Message.error('Get overview error: ' + error.message)
        })
    },
    getDesignReport() {
      let startRange = this.designDateRangeInput[0].toISOString()
      let endRange = this.designDateRangeInput[1].toISOString()
      let queryString = '?limit=100&date>=' + startRange + '&date<=' + endRange
      api({
        method: 'get',
        url: 'reports/designs' + queryString
      })
        .then(res => {
          this.designReport = res.data.rows

          console.log('this.design', this.designReport)
        })
        .catch(error => {
          this.$Message.error('Get designs report error: ' + error.message)
        })
    }
  },
  watch: {}
}
</script>
<style>
.about {
  width: 100%;
}
</style>
